import { render, staticRenderFns } from "./modalSendPushNotification.vue?vue&type=template&id=86567512&"
import script from "./modalSendPushNotification.vue?vue&type=script&lang=js&"
export * from "./modalSendPushNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports